module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M23.236 0H8.764c-1.106 0-1.6.8-1.106 1.79l2.446 4.89A13.892 13.892 0 0 0 16 8a13.9 13.9 0 0 0 5.898-1.32l2.444-4.89c.494-.99 0-1.79-1.106-1.79zm.552 10.204A17.857 17.857 0 0 1 16 12c-2.802 0-5.448-.662-7.816-1.81C3.318 12.922 0 18.098 0 24.062V30c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2v-6c0-5.928-3.328-11.07-8.212-13.796z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/sack-1.js
// module id = 1397
// module chunks = 14